import { createFileRoute } from '@tanstack/react-router'
import { listSearchSchema } from '@/lib/list-search-schema'
import VoicemailTab from '@/components/organisms/VoicemailTab'

const voicemailSearchSchema = listSearchSchema

export const Route = createFileRoute('/_authenticated/phone/voicemail')({
  validateSearch: voicemailSearchSchema,
  component: VoicemailTab,
})
